export async function checkPolicy(to, from, next) {
	if (to.params.contract && /^-?\d+$/.test((to.params.contract))) {
		next();
	} else {
		next({ name: "individual" })
	}
}

